import * as moment from "moment";
import { DateAndStatusTask, HourTypeWithValidations, SEstado } from "./select-interface";
import { localDB } from "src/app/shared/helpers/localStorage";
import { configurations } from "src/app/shared/interfaces/configurations.interface";

const getLastWorkDayCompleted = (status: DateAndStatusTask[], condition: any) => {
  for (let i = status.length - 1; i >= 0; i--) {
    if (condition(status[i])) {
      return i;
    }
  }
  return -1;
};

const substractDate = (dateInString: string, quantity: number): string => {
  let date = new Date(dateInString);
  date.setDate(date.getDate() - quantity);
  let year: number = date.getFullYear();
  let month: string = (date.getMonth() + 1).toString().padStart(2, '0');
  let day: string = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const filterJournals = (status: DateAndStatusTask[], lastJournalDay: string): DateAndStatusTask[] => {
  return status.filter(estado => {
    let validator: string  = lastJournalDay;

    if (estado.dRegistrationDate === lastJournalDay) {
      validator = lastJournalDay
    } else {
      validator = substractDate(lastJournalDay, 0);
    }

    return estado.dDate <= validator;
  });
};

export function setInvalidOptionInSelectComponent(scheduleType: configurations[], status: DateAndStatusTask[]): HourTypeWithValidations[] {
  let lastJournalDate: string = JSON.parse(localDB.getItem('V-HORARIO')).dFecha_Jornada;
  let filteredStates: DateAndStatusTask[] = filterJournals(status.filter((x: any) => x.nReadyMark!==0), lastJournalDate);
  let incomplete: boolean = filteredStates.some((x: DateAndStatusTask) => x.sEstado !== SEstado.Completo || x.sEstado==null);

  let firstDateIncompleteIndex: number = filteredStates.findIndex(x => x.sEstado!==SEstado.Completo);
  let lastDateIncompleteIndex: number = getLastWorkDayCompleted(filteredStates, (x: DateAndStatusTask) => x.sEstado !== SEstado.Completo);

  if (filteredStates.length > 0) {
    return scheduleType.map((tipo_hora: HourTypeWithValidations) => 
      ({
        ...tipo_hora,
        firstDate: (filteredStates[firstDateIncompleteIndex]) ? filteredStates[firstDateIncompleteIndex].dDate : "",
        lastDate: (filteredStates[lastDateIncompleteIndex]) ? filteredStates[lastDateIncompleteIndex].dDate : "",
        bIsInvalidOption: (tipo_hora.sCodigo == "1") ? false : incomplete,
        // bIsInvalidOption: false,
      })
    );
  };

  return scheduleType.map((tipo_hora: HourTypeWithValidations) => ({
    ...tipo_hora,
    firstDate: "",
    lastDate: "",
    bIsInvalidOption: false,
  }));
};

export const getDateInMomentFormatSinceToday = (days: number = 0): string => {
  const currentDate = new Date();
  if (days !== 0) currentDate.setDate(currentDate.getDate() + days);
  return moment(currentDate).format("YYYY-MM-DD");
};
